exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.modal-footer-rejection{text-align:center;margin-top:-30px;margin-bottom:20px;background-color:lightcoral;color:#fafafa;visibility:hidden}\n", ""]);

// exports
